<template>
  <form @submit.prevent>
    <div>
      <h2>
        <span v-if="isEditMode">{{ $t("audit-control.audit.name") }} "{{ editedEntity.name | translate }}" {{ $t("common.update") }}</span>
        <span v-else>{{ $t("audit-control.audit.new") }}</span>
      </h2>

      <div class="row">
        <!-- Name -->
        <div class="col-md-12">
          <sweet-input v-model="form.name" :isValid="!$v.form.name.$error" layout="vertical" :label="$t('audit-control.audit.name')" />
        </div>
      </div>

      <div class="row">
        <!-- Dates -->
        <div class="col-md-6">
          <div class="form-group">
            <label>{{ $t("audit-control.audit.start-date") }} <span class="text-danger">*</span></label>
            <input type="date" class="form-control" v-model="form.startDate" :class="{ 'is-invalid': $v.form.startDate.$error }" />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>{{ $t("audit-control.audit.end-date") }} <span class="text-danger">*</span></label>
            <input type="date" class="form-control" v-model="form.endDate" :class="{ 'is-invalid': $v.form.endDate.$error }" />
          </div>
        </div>
      </div>

      <!-- <div class="row">
      
        <div class="col-md-6">
          <div class="form-group">
            <label>{{ $t("audit-control.audit.status.text") }}</label>
            <select class="form-control" v-model="form.status" :class="{ 'is-invalid': $v.form.status.$error }">
              <option value="PLANNED">{{ $t("audit-control.audit.status.planned") }}</option>
              <option value="IN_PROGRESS">{{ $t("audit-control.audit.status.in_progress") }}</option>
              <option value="COMPLETED">{{ $t("audit-control.audit.status.completed") }}</option>
              <option value="CANCELLED">{{ $t("audit-control.audit.status.cancelled") }}</option>
            </select>
          </div>
        </div>
      </div> -->

      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label>{{ $t("audit-control.audit.leader") }}</label>
            <organization-member-select :selected="form.leader" @onSelect="form.leader = $event" />
          </div>
        </div>
        <div class="col-md-6">
          <sweet-input v-model="form.plannedResource" :isValid="true" layout="vertical" :label="$t('audit-control.audit.planned-resource')" />
        </div>
      </div>

      <div class="row">
        <!-- Auditors -->
        <div class="col-md-12">
          <div class="form-group">
            <label>{{ $t("audit-control.audit.auditors") }}</label>
            <organization-member-select :selected="form.auditors" :multiple="true" @onSelect="form.auditors = $event" />
          </div>
        </div>
      </div>

      <div class="row">
        <!-- Description -->
        <div class="col-md-12">
          <sweet-textarea v-model="form.description" :isValid="true" :rows="3" layout="vertical" :label="$t('audit-control.audit.description')" />
        </div>
      </div>

      <sweet-button @click="save()" type="submit" :loading="isUpdating" :disabled="isUpdating || $v.$invalid" variant="success" icon="mdi mdi-check" size="sm" buttonClass="mt-2">
        {{ $t("common.save") }}
      </sweet-button>
    </div>
  </form>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import SweetInput from "@c/form/sweet-input";
import SweetTextarea from "@c/form/sweet-textarea";
import OrganizationMemberSelect from "@cc/organization-member-select";

const state = "organizationAudit";

export default {
  components: {
    SweetInput,
    SweetTextarea,
    OrganizationMemberSelect,
  },
  data() {
    return {
      form: {
        name: undefined,
        startDate: undefined,
        endDate: undefined,

        description: undefined,
        leader: undefined,
        auditors: [],
        plannedResource: undefined,
      },
    };
  },
  validations: {
    form: {
      name: { required },
      startDate: { required },
      endDate: { required },
    },
  },
  computed: {
    isUpdating() {
      return this.$store.getters[`${state}/isUpdating`];
    },
    editedEntity() {
      return this.$store.getters[`${state}/editedEntity`];
    },
    isEditMode() {
      return this.$store.getters[`${state}/isEditMode`];
    },
  },
  watch: {
    editedEntity: {
      deep: true,
      immediate: true,
      handler(v) {
        if (v) {
          const entity = this.prepareFormForEdit(v);
          // Handle Date conversion for input type=date
          if (entity.startDate) entity.startDate = new Date(entity.startDate).toISOString().split("T")[0];
          if (entity.endDate) entity.endDate = new Date(entity.endDate).toISOString().split("T")[0];

          this.form = { ...entity };
        } else {
          this.form = {
            name: undefined,
            startDate: undefined,
            endDate: undefined,
            // status: "PLANNED",
            description: undefined,
            leader: undefined,
            auditors: [],
            plannedResource: undefined,
          };
        }
      },
    },
  },
  methods: {
    async save() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      try {
        const payload = {
          ...this.form,
        };
        const { data } = await this.$store.dispatch(`${state}/save`, payload);
        this.form = { leader: undefined, auditors: [], plannedResource: undefined };
        this.$v.$reset();
        this.$toast.success(this.$t("common.success"));
        this.$emit("onSave", data);

        this.$root.$emit("bv::toggle::collapse", "sidebar-new-audit");
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
  },
};
</script>
